<div class="_statistics-desktop-page">

	<segment-desktop-component [segments]="segments" [selectedSegment]="selectedSegment" (selectedSegmentChange)="onSelectedSegmentChange($any($event))"></segment-desktop-component>

	<ng-container [ngSwitch]="selectedSegment">

		<!-- Impact -->
		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[0])">
			<impact-statistics-component></impact-statistics-component>
		</div>

		<!-- Bezoekers -->
		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[1])">
			<client-statistics-component></client-statistics-component>
		</div>

		<!-- Activiteiten -->
		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[2])">
			<activity-statistics-component></activity-statistics-component>
		</div>

		<!-- Attendances -->
		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[3])">
			<attendance-statistics-component></attendance-statistics-component>
		</div>

		<!-- Anonieme bezoekers -->
		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[4])">
			<anonymous-attendance-statistics-component></anonymous-attendance-statistics-component>
		</div>

		<!-- Beoordelingen van reservaties -->
		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[5])">
			<rating-statistics-component></rating-statistics-component>
		</div>

		<!-- Annulaties van reservaties -->
		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[6])">
			<cancellation-statistics-component></cancellation-statistics-component>
		</div>

		<!-- Uitleendienst -->
		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[7])">
			<loan-statistics-component></loan-statistics-component>
		</div>

		<!-- BEEGO -->
		<!-- <div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[8])">
			
		</div> -->

		<!-- Digicheques -->
		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[8])">
			<digicheque-statistics-component></digicheque-statistics-component>
		</div>

	</ng-container>

</div>
